/* Copyright (C) 2020 Soil Capital Belgium SPRL - All Rights Reserved */
import React from "react";

//UI Components
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";

const BlankIcon = () => <RadioButtonUncheckedIcon style={{ opacity: 0 }} />;

export default BlankIcon;
